import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as onlineappointmentAPI from "./OnlineAppointmentAPI";
import axios from "axios";
import API_BASE_URL from "../BaseURL/baseURL";

export const fetchtimeslab = createAsyncThunk(
  "OnlineAppointment/fetchtimeslab",
  async (pde_id) => {
    const response = await onlineappointmentAPI.fetchtimeslab(pde_id);
    return response;
  }
);

export const fetchSROAppointmnet = createAsyncThunk(
  "OnlineAppointment/fetchSROAppointmnet",
  async ({ pde, AppointmentDate, timeSlab }) => {
    const response = await onlineappointmentAPI.fetchSROs(
      pde,
      AppointmentDate,
      timeSlab
    );
    return response;
  }
);

export const fetchBookSROAppointment = createAsyncThunk(
  "OnlineAppointment/fetchBookSROAppointment",
  async (payload) => {
    //debugger;
    try {
      const { mode, ...appointmentDetails } = payload;
      const response = await onlineappointmentAPI.fetchBookSROAppointment(
        appointmentDetails,
        mode
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchAppointmentDetailsModify = createAsyncThunk(
  "OnlineAppointment/fetchAppointmentDetailsModify",
  async (pdeid, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/OnlineAppointment/GetAppointmentDetails?PDEid=${pdeid}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  status: "idle",
  error: null,
  AppointmentDate: "",

  mode: "",
  pdeid: "",
  appointmentDetails: null,
  bookappointment: [],
};

export const onlineappointmentSlice = createSlice({
  name: "OnlineAppointment",
  initialState,
  reducers: {
    resetTimeSlab: (state) => {
      //state.timeSlab = initialState.timeSlab;
      // state.sroAppointments = initialState.sroAppointments;
      state.bookappointment = initialState.bookappointment;
      state.mode = initialState.mode;
      state.pdeid = initialState.pdeid;
    },
    setAppointmentInfo(state, action) {
      //debugger;
      console.log(action);
      state.mode = action.payload.mode;
      state.pdeid = action.payload.PDE_ID;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchtimeslab.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchtimeslab.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.timeSlab = action.payload;
      })
      .addCase(fetchtimeslab.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchSROAppointmnet.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSROAppointmnet.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.sroAppointments = action.payload;
      })
      .addCase(fetchSROAppointmnet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchBookSROAppointment.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBookSROAppointment.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.bookappointment = action.payload.data[0];
        console.log("Payload received:", action.payload.data[0]);

        if (
          action.payload.bookappointment &&
          action.payload.bookappointment.length > 0
        ) {
          state.bookappointment = action.payload.bookappointment[0];
        }
        window.location.reload();
      })
      .addCase(fetchBookSROAppointment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchAppointmentDetailsModify.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAppointmentDetailsModify.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.appointmentDetails = action.payload;
      })
      .addCase(fetchAppointmentDetailsModify.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const timeSlabOptions = (state) => state.OnlineAppointment.timeSlab;
export const selectSROAppointments = (state) =>
  state.OnlineAppointment.sroAppointments;
export const selectbookappointment = (state) =>
  state.OnlineAppointment.bookappointment;

export const { resetTimeSlab } = onlineappointmentSlice.actions;
export const { setAppointmentInfo } = onlineappointmentSlice.actions;

export default onlineappointmentSlice.reducer;
